/* eslint-disable dot-notation */
import { ApolloError } from '@apollo/client';
import { useFlags } from 'launchdarkly-react-client-sdk';

import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { LoadFailureError } from 'src/errors';

enum PerformanceMode {
  normal = 'normal',
  disabled = 'disabled',
}

function useLoadPerformanceMode(): void {
  const flags = useFlags();
  const { error } = useDispensary();

  const performanceFlagValue = flags['ecomm.config.low-performance-mode'];
  const shouldAutomaticallyDisable = flags['ecomm.rollout.automatic-site-disabling'] ?? false;

  const requestFailed =
    error instanceof ApolloError &&
    'networkError' in error &&
    error.networkError &&
    error.networkError['statusCode'] >= 502 &&
    error.networkError['statusCode'] <= 511;

  if (performanceFlagValue === PerformanceMode.disabled || (requestFailed && shouldAutomaticallyDisable)) {
    throw new LoadFailureError();
  }
}

export function LoadPerformanceMode(): null {
  useLoadPerformanceMode();

  return null;
}
